export const DEFAULT_USER_SETTINGS = {
    charactersSettings: {
        showPlayersHpAc: true,
        showEnemiesHpAc: false,
        showCharactersStatus: true,
    },
    screenSaverSettings: {
        enabled: false,
        screenSaver: 'default',
        charactersIds: [],
    },
};
